import axios from "axios";

/** Base API sans double /api (tolère REACT_APP_BACKEND_URL avec ou sans suffixe /api). */
function resolveApiBase() {
  let raw = (process.env.REACT_APP_BACKEND_URL || "https://api.groupe-aulia.io").trim().replace(/\/+$/, "");
  if (/\/api$/i.test(raw)) {
    raw = raw.replace(/\/api$/i, "");
  }
  return `${raw}/api`;
}

export const API = resolveApiBase();

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aulia_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/register") && !path.startsWith("/invitation")) {
        localStorage.removeItem("aulia_token");
        window.location.href = "/login";
      }
    }
    // Rôle insuffisant (lecteur / membre) : message uniforme, les pages gèrent déjà les cadenas d'offre
    const detail = err?.response?.data?.detail;
    if (err?.response?.status === 403 && detail && typeof detail === "object" && detail.code === "role_forbidden") {
      import("sonner").then(({ toast }) => toast.error(detail.message || "Votre rôle ne permet pas cette action")).catch(() => {});
    }
    return Promise.reject(err);
  }
);

export default api;
